import apiClient from './apiClient';

/**
 * Active course catalog categories for the current institute (from GET /courses/catalog-categories).
 */
export async function fetchCourseCatalogCategories() {
  try {
    const { data } = await apiClient.get('/courses/catalog-categories');
    if (Array.isArray(data?.data)) return data.data;
  } catch {
    /* network / auth */
  }
  return [];
}
